import { basePath } from './core/config'
__webpack_public_path__ = `${basePath}/assets/frontend/js/`
// required
// import 'babel-polyfill';

// default scripts
import 'console-polyfill';
import 'es5-shim';
import FastClick from 'fastclick';
// import $ from 'jquery';

FastClick.attach(document.body);

import $ from 'jquery';

// jquery utils
import 'jquery.easing';

import './plugins/nette.ajax';
import './plugins/giant.trigger';
import './plugins/giant.autosubmit';

// nette
import './nette/NetteFormFilled';
import './nette/NetteForms';
import './nette/NetteValidationMessages';
import './nette/NetteSnippets';

import Nette from './nette/NetteForms';
import antispam from './modules/antispam';
window.Nette = Nette;
Nette.initOnLoad();

if ($.nette) {
    $.nette.init();
}

import components from './components/';
import { loadComponents } from './core/componentUtils';

window.app = {
    components: components
};

FastClick.attach(document.body);

import { queryAll } from './utils/dom'
import { decode } from './utils/htmlentities'
// mail encoding
queryAll('a[data-lto]')
    .forEach(element => {
        element.setAttribute('href', `mailto:${decode(element.dataset.lto)}`)
    })

loadComponents();



// WEBPACK FOOTER //
// ./app.js